import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createNotification,
  deleteNotification,
  notificationQueryKeys,
  updateNotification,
} from '@/entities/notification';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

/**
 * Subscription Workflow 생성 mutation
 */
export function useCreateSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SUBSCRIPTION]),
      });
    },
  });
}

/**
 * Subscription Workflow 수정 mutation
 */
export function useUpdateSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SUBSCRIPTION]),
      });
    },
  });
}

/**
 * Subscription Workflow 삭제 mutation
 */
export function useDeleteSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SUBSCRIPTION]),
      });
    },
  });
}
